import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

//
import './index.css';
import App from './App';

// ----------------------------------------------------------------------

// ResizeObserver 에러를 전역적으로 조용히 처리
const originalError = console.error;
console.error = (...args) => {
  const firstArg = args[0];
  if (
    typeof firstArg === 'string' &&
    firstArg.includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    // ResizeObserver 에러는 무시 (개발 환경에서만 출력)
    if (process.env.NODE_ENV === 'development') {
      console.warn('ResizeObserver warning suppressed:', firstArg);
    }
    return;
  }
  originalError(...args);
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense>
        <App />
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);
